import { css } from '@emotion/react';

import { useTranslation } from 'i18n';

const tableCss = css`
  border-collapse: collapse;
  border-spacing: 0;
  font-size: 0.9rem;

  & td {
    border-color: black;
    border-style: solid;
    border-width: 1px;
    overflow: hidden;
    padding: 8px;
    word-break: normal;
  }

  & th {
    border-color: black;
    border-style: solid;
    border-width: 1px;
    overflow: hidden;
    padding: 8px;
    word-break: normal;
  }
`;

function CacheTableInstructions() {
  const { t } = useTranslation();

  return (
    <table css={tableCss}>
      <thead>
        <tr>
          <th> </th>
          <th>{t('errorPage.help.cacheTable.operatingSystem.pc')}</th>
          <th>{t('errorPage.help.cacheTable.operatingSystem.mac')}</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>{t('errorPage.help.cacheTable.browser.chrome')}</td>
          <td rowSpan="3">{t('errorPage.help.cacheTable.instructions.pc')}</td>
          <td rowSpan="2">{t('errorPage.help.cacheTable.instructions.mac')}</td>
        </tr>
        <tr>
          <td>{t('errorPage.help.cacheTable.browser.firefox')}</td>
        </tr>
        <tr>
          <td>{t('errorPage.help.cacheTable.browser.ie')}</td>
          <td>NA</td>
        </tr>
      </tbody>
    </table>
  );
}

export default CacheTableInstructions;
